import { render, staticRenderFns } from "./concernedEn.vue?vue&type=template&id=09a06496&scoped=true&"
import script from "./concernedEn.vue?vue&type=script&lang=js&"
export * from "./concernedEn.vue?vue&type=script&lang=js&"
import style0 from "./concernedEn.vue?vue&type=style&index=0&id=09a06496&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a06496",
  null
  
)

export default component.exports